import { Theme } from '@src/styled-components';
import { Col, Icon, Row } from 'antd';
import React from 'react';

import styled from '../../node_modules/styled-components';

interface IProp {
    title: string
    collapsed: boolean
    onClick: Function
    style?: any
    styleTitle?: any;
    styleIcon?: any;
}

export default class CollapsableComponent extends React.Component<IProp, {}> {
    
    render() {
        const icon = this.props.collapsed ? <Icon style={this.props.styleIcon !== undefined ? this.props.styleIcon : {fontSize:'9px', verticalAlign: '1px'}} type="caret-down" /> : 
                                            <Icon style={this.props.styleIcon !== undefined ? this.props.styleIcon : {fontSize:'9px', verticalAlign: '0px'}} type="caret-up" />;

        return (
            <Row style={this.props.style} >
                <Col sm={24} md={24} xl={24}>
                    <GoEpikClickableCursor>
                        <Row onClick={() => this.props.onClick()} className="goepik-clickable">
                            <Col sm={24} md={24} xl={24}>
                                <div style={{color: Theme.primary.regular, fontWeight: 'bold'}} >
                                    <p style={this.props.styleTitle}>{this.props.title} {icon}</p>
                                </div>
                            </Col>
                        </Row>
                    </GoEpikClickableCursor>
                    {
                        (!this.props.collapsed) &&
                        this.props.children
                    }
                </Col>
            </Row>
        );
    }
};

const GoEpikClickableCursor = styled.div`
    .goepik-clickable{
        cursor: pointer;
        color: blue;
    }
`;